import React from "react";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
} from "@mui/material";
import Matt from "../../assets/Matt.jpg";
import AscendLogo from "../../assets/logo/AscendLawLogo.png";
import ExtraTicks from "../../assets/ExtraTicks.svg";
import Quickbooks from "../../assets/logo/Quickbooks.svg";

const LegalSupportPage = () => {
  const services = [
    "Funding rounds & investment (pre-seed - series B)",
    "Founders & shareholder agreements",
    "SEIS & EIS advance assurance",
    "Employment option schemes (EMI) & incentives",
    "Exits (merges & acquisitions)",
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ml: 6,
        p: 4,
        bgcolor: "#f4f7fb",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        <Box sx={{ mb: 4 }}>
          <img
            src={AscendLogo}
            alt="AscendLogo"
            width={"200px"}
            style={{ cursor: "pointer" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.02)";
              e.currentTarget.style.opacity = "0.6";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.opacity = "1";
            }}
            onClick={() => {
              window.open(
                "https://augustlaw.co.uk",
                "_blank"
              );
            }}
          yy/>
          <Typography sx={{ fontSize: "1.1rem" }}>
            Ensure that you company remains protected by accessing high-quality
            legal support.
          </Typography>
        </Box>
        <Button
          sx={{
            borderRadius: "5px",
            height: "40px",
            backgroundColor: "#2468FF",
            color: "#ffffff",
            marginTop: "1rem",
            marginLeft: "0.5rem",
            fontWeight: 600,
            padding: "0.5rem 1.5rem",
            textTransform: "none",
            width: "max-content",
            "&:hover": {
              backgroundColor: "#b4a4f5",
            },
          }}
          onClick={() => {
            window.open("https://augustlaw.co.uk", "_blank");
          }}
        >
          Find out more
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            p: 3,
            bgcolor: "#FFFFFF",
            borderRadius: "10px",
            mr: 8,
            height: "100%",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Legal Services to Keep your Business Protected
          </Typography>
          <List>
            {services.map((service, index) => (
              <ListItem key={index} sx={{ padding: "0.25rem 0", mt: 0.5 }}>
                <img src={ExtraTicks} alt="ExtraTicks" width={"35px"} />
                <Typography sx={{ ml: 2, fontSize: "1.1rem" }}>
                  {service}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            maxWidth: "500px",
          }}
        >
          <Box
            sx={{
              bgcolor: "#FFFFFF",
              borderRadius: "10px",
              p: 3,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "250px",
              }}
            >
              <Typography
                sx={{ fontSize: "1.1rem", fontWeight: "medium" }}
                gutterBottom
              >
                Speak with our Head of Legal today.
              </Typography>

              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "5px",
                  height: "40px",
                  backgroundColor: "#2468FF",
                  color: "#ffffff",
                  marginTop: "1rem",
                  marginLeft: "0.5rem",
                  fontWeight: 600,
                  padding: "1rem 2rem",
                  textTransform: "none",
                  width: "max-content",
                  "&:hover": {
                    backgroundColor: "#b4a4f5",
                  },
                }}
                onClick={() => {
                  window.open(
                    "https://meetings.hubspot.com/matt2751/ascend-law",
                    "_blank"
                  );
                }}
              >
                Book a call
              </Button>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src={Matt}
                alt="Team member"
                style={{
                  width: "110px",
                  height: "130px",
                  borderRadius: "5%",
                  marginRight: "1rem",
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              bgcolor: "#0D333F",
              borderRadius: "10px",
              p: 3,
              display: "flex",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                maxWidth: "250px",
              }}
            >
              <Typography
                sx={{ fontSize: "1.1rem", fontWeight: "medium", color: "#fff" }}
                gutterBottom
              >
                Claim your discounted Quickbooks Accounting Software package
                today.
              </Typography>

              <Button
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: "5px",
                  height: "40px",
                  backgroundColor: "#fff",
                  color: "#000",
                  marginTop: "1rem",
                  marginLeft: "0.5rem",
                  fontWeight: 600,
                  padding: "1rem 2rem",
                  textTransform: "none",
                  width: "max-content",
                  "&:hover": {
                    backgroundColor: "#b4a4f5",
                  },
                }}
                onClick={() => {
                  window.open(
                    "https://quickbooks.partnerlinks.io/qb-discounted-pricing-plans",
                    "_blank"
                  );
                }}
              >
                Find out more
              </Button>
            </Box>
            <Box sx={{ display: "flex" }}>
              <img
                src={Quickbooks}
                alt="Team member"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  marginRight: "1rem",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LegalSupportPage;
